import React, { ComponentType } from 'react';

const withOutsideClickDetection = (BaseComponent: ComponentType) => {
  interface HocProps {
    onClickOutside: () => void;
    onKeyPress: (event: KeyboardEvent) => void;
  }

  return class extends React.Component<HocProps, {}> {
    private readonly myRef: React.RefObject<HTMLDivElement>;
    constructor(props: HocProps) {
      super(props);
      this.myRef = React.createRef();
    }
    componentDidMount() {
      document.addEventListener('click', this.onClickEvent, true);
      document.addEventListener('keydown', this.onKeyPressEvent, true);
    }

    componentWillUnmount() {
      document.removeEventListener('click', this.onClickEvent, true);
      document.removeEventListener('keydown', this.onKeyPressEvent, true);
    }

    onClickEvent = (event: MouseEvent) => {
      const domNode = this.myRef.current;
      const {onClickOutside} = this.props;
      if (onClickOutside && domNode && !domNode.contains(event.target as Node)) {
        onClickOutside();
      }
    }

    onKeyPressEvent = (event: KeyboardEvent) => {
      const {onKeyPress} = this.props;
      if (onKeyPress) {
        onKeyPress(event);
      }
    }

    render() {
      return (<div ref={this.myRef}><BaseComponent {...this.props} /></div>);
    }
  };
};

export { withOutsideClickDetection };
